import * as orders from '../orders';
import * as api from '../api';

export class OrderService {
    convertToOrders(reservations: api.ReservationStatusResult[]): orders.OrderModel[] {
        const result: orders.OrderModel[] = [];

        reservations.forEach(function (r) {
            result.push(new orders.OrderModel(r));
        });

        return result;
    }
}
